import { useTheme } from '@emotion/react';
import { IconCheckCircleFilled } from '@hubble/icons/web';
import { useState, useEffect } from 'react';
import { CircleProgressWrapper, ToggleItem, InnerLoader, AnimatedCircle } from './styles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { getColor } from '../utils/themeUtils.js';
import { Colors } from '../primitives/color.js';

const LOADER_DURATION = 100;
const CHECK_DURATION = 500;
const cleanPercentage = percentage => {
  const tooLow = !Number.isFinite(Number(percentage)) || percentage < 0;
  const tooHigh = percentage > 100;
  return tooLow ? 0 : tooHigh ? 100 : Number(percentage);
};
const CIRCLE_VARIATIONS = {
  BASE: 'base',
  SUCCESS: 'success',
  LOADING: 'loading'
};
const Circle = ({
  size,
  variation,
  percentage = 100
}) => {
  const r = size / 2;
  const circ = 2 * Math.PI * r;
  const strokePct = (100 - percentage) * circ / 100;
  return jsx(AnimatedCircle, {
    duration: LOADER_DURATION,
    r: r - 1,
    cx: size / 2,
    cy: size / 2,
    fill: "transparent",
    variation: variation,
    strokeWidth: "2px",
    strokeDasharray: circ,
    strokeDashoffset: strokePct
  });
};
const Loader = ({
  size,
  percentage
}) => {
  return jsx(InnerLoader, {
    children: jsx("svg", {
      width: size,
      height: size,
      children: jsxs("g", {
        transform: `rotate(-90 ${size / 2} ${size / 2})`,
        children: [jsx(Circle, {
          size: size,
          variation: CIRCLE_VARIATIONS.BASE
        }), jsx(Circle, {
          size: size,
          variation: percentage === 100 ? CIRCLE_VARIATIONS.SUCCESS : CIRCLE_VARIATIONS.LOADING,
          percentage: percentage
        })]
      })
    })
  });
};
const CircularProgress = ({
  size = 20,
  percentage
}) => {
  const pct = cleanPercentage(percentage);
  return jsxs(CircleProgressWrapper, {
    duration: CHECK_DURATION,
    size: size,
    children: [jsx(Loader, {
      percentage: pct,
      size: size
    }), jsx(Check, {
      percentage: pct
    })]
  });
};
const Check = ({
  percentage
}) => {
  const theme = useTheme();
  const [completed, setCompleted] = useState(percentage === 100);
  useEffect(() => {
    if (percentage === 100) {
      setTimeout(() => {
        setCompleted(true);
      }, LOADER_DURATION);
    }
  }, [percentage]);
  return jsx(ToggleItem, {
    isHidden: !completed,
    children: jsx(IconCheckCircleFilled, {
      size: "sm",
      color: getColor(Colors.green[600], Colors.green[300])({
        theme
      })
    })
  });
};

export { CircularProgress };
